import contentBlocker from './content-blocker';
import overlay from './overlay';

class ModalService {
    constructor() {
        this.openedModal = null;
        this.hasPreviousOpenedModal = null;
    }

    close(modal, isPassive) {
        if (this.openedModal && this.openedModal === modal && this.hasPreviousOpenedModal === null) {
            this.openedModal = null;
            return modal.onClose(isPassive).then(() => {
                this._afterClose();
            });
        }
        if (this.openedModal && this.openedModal === modal && this.hasPreviousOpenedModal !== null) {
            this.openedModal = this.hasPreviousOpenedModal;
            this.hasPreviousOpenedModal = this.getPreviousOpenedModal(this.hasPreviousOpenedModal);
            return modal.onClose(isPassive);
        }
        return Promise.resolve();
    }

    closeModal(isPassive) {
        if (this.openedModal && this.hasPreviousOpenedModal === null) {
            return this.openedModal.onClose(isPassive).then(() => {
                this._afterClose();
            });
        }
        if (this.openedModal && this.hasPreviousOpenedModal !== null) {
            return this.openedModal.onClose(isPassive).then(() => {
                this.openedModal = this.hasPreviousOpenedModal;
                this.hasPreviousOpenedModal = this.getPreviousOpenedModal(this.hasPreviousOpenedModal);
            });
        }
        return Promise.resolve();
    }

    closePreviousModal(isPassive) {
        if (this.hasPreviousOpenedModal !== null) {
            return this.hasPreviousOpenedModal.onClose(isPassive).then(() => {
                this.hasPreviousOpenedModal = this.getPreviousOpenedModal(this.hasPreviousOpenedModal);
            });
        }
        return Promise.resolve();
    }

    open(modal, options) {
        this._beforeOpen();

        if (this.openedModal) {
            if (this.openedModal !== modal) {
                this.hasPreviousOpenedModal = this.openedModal;
                modal.options.previousOpenedModal = this.hasPreviousOpenedModal;
            }
        }

        modal.onOpen(options);
        this.openedModal = modal;
    }

    getPreviousOpenedModal(modal) {
        return modal ? modal.options.previousOpenedModal : null;
    }

    _beforeOpen() {
        contentBlocker.block('modal');
        overlay.show('modal');
    }

    _afterOpen() {
    }

    _beforeClose() {
    }

    _afterClose() {
        contentBlocker.unblock('modal');
        overlay.hide('modal');
    }

    closeOpened() {
        if (this.openedModal) {
            this.openedModal.close(true);
        }
    }
}

const instance = new ModalService();
export default instance;
